import { StoreResult } from "@/store/CertificateStore";
import { Resource, SMACertificate } from "@/types/Administration/SMA/SMACertificate";
import Dictionary from "@/types/Dictionary";

export abstract class AbstractSignatureStrategy {
    protected store;

    /** Indique si cette stratégie nécessite l'étape du mot de passe */
    public abstract readonly requiresPasswordValidation: boolean;

    /**
     * Constructeur
     * @param store Store CertificateStore 
     */
    constructor(store){
        this.store = store;
    }

    /**
     * Récupération du mandat format base
     * @param parameters 
     */
    abstract execute(params: { item: SMACertificate; resource: Resource[] }): Promise<StoreResult<Blob>>;
    /**
     * Submit de la signature
     * @param parameters 
     */
    abstract validation(parameters: Dictionary<any>): Promise<StoreResult<Blob>>;
}
